import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/eurojackpot/spielen/external',
      canonical: {
        path: '/eurojackpot/spielen',
        workspace: 'website',
      },
      gameEurojackpot: 'external',
      noindex: true,
      game: 'Eurojackpot',
      external: true,
      description:
        'Ihr Eurojackpot-Spielschein für Europas Millionenlotterie - Zahlen online tippen und Spielschein sicher abgeben',
      title: 'Eurojackpot online spielen',
    },
  };
}
